export const types = {
  GET: "@BARS_DATA/GET",
  UPDATE: "@BARS_DATA/UPDATE",
};
